/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-30 13:37:13
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-14 17:28:44
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/LegalPageEditor/Content/index.tsx
 */

import { SectionContent } from '@/src/layout/EditorPageLayout/EditorCollapsePageLayout';
import { useI18n } from 'src/hooks/useRouterChange';
import { getI18nFromGeneral, i18nGet } from '@/src/tools/tools';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Editor from 'src/constrains/BraftEditor';
import SectionHOC from 'src/pages/SalesCannelVersion/SalesChannelLegal/Components/HOC';
import {
  EnumCollapseId,
  getCollapse,
  getContent,
  onCollapseChange,
  onContentChange,
} from 'src/pages/SalesCannelVersion/SalesChannelLegal/LegalPageEditor/slice';
import { generateErrorKey } from 'src/tools/helper';
import { legalPermissions } from '../../Components/hooks/permission';
import css from './css.module.less';

const configFront = [
  'undo',
  'redo',
  'separator',
  'font-size',
  'line-height',
  'letter-spacing',
  'separator',
  'text-color',
  'bold',
  'italic',
  'underline',
  'strike-through',
  'separator',
  'superscript',
  'subscript',
  'remove-styles',

  'separator',
  'text-indent',
  'text-align',
  'separator',
  'headings',
  'list-ul',
  'list-ol',
  'blockquote',

  'separator',
  'media',
  'code',
];
const configBack = ['separator', 'hr', 'separator', 'clear'];
const Content = (props: any) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const _data: any = useSelector(getContent());
  const _editor = React.useRef<any>(null);

  const _d = useDispatch();
  const { uuid }: any = useParams();
  const { canEdit } = legalPermissions(uuid);
  const {
    content: _content,
    loaded,
    //isNameDuplicate
  } = _data || {};
  const { content } = _content || {};

  React.useEffect(() => {
    if (loaded && _editor.current && _editor.current.setData) {
      _editor.current.setData(content);
    }
  }, [loaded]);

  const contentErr = _content[generateErrorKey('content')];
  const handleOnContentChange = ({ data, isEmpty }) => {
    _d(onContentChange({ content: data, isEmpty }));
  };
  return (
    <SectionContent className={css.container}>
      <Editor
        linkSet={props.linkSet}
        ref={(e) => (_editor.current = e)}
        id='SalesChannelLegalPageEditorContent'
        err={contentErr}
        data={content}
        onChange={handleOnContentChange}
        configFront={configFront}
        configBack={configBack}
        disabled={!canEdit}
        contentStyle={{ minHeight: 200, resize: 'vertical', overflow: 'auto' }}
      />
      <div className={css.remark}>{getI18n('legalPage.index.legalremark')}</div>
    </SectionContent>
  );
};

export default SectionHOC(Content, {
  id: EnumCollapseId.Content,
  title: getI18nFromGeneral('general.sider.content'),
  getCollapse,
  onCollapseChange,
});
